import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./CorrespondenceHistory.module.scss";

interface ICorrespondenceHistoryItemProps {
    providerName: string;
    patientName: string;
    preventiveItem: string;
    notice: string;
    generationDate: string;
}

function CorrespondenceHistoryItem(props: ICorrespondenceHistoryItemProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={styles.divider}>
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label bold">{getText("ProviderLabel")}</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 form-field-answer">
                    {props.providerName}
                </div>
            </div>
            <div className="row flex flex-row flex-align-items-center">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label bold">{getText("PatientLabel")}</label>
                </div>
                <div className="col-lg-5 col-md-5 col-sm-5 form-field-answer">
                    {props.patientName}
                </div>
            </div>
            <div className="row flex flex-row flex-align-items-center">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label bold">{getText("PreventiveItemLabel")}</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 form-field-answer">
                    {props.preventiveItem}
                </div>
            </div>
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label bold">{getText("PreventiveCare_CorrespondenceHistory_NoticeGeneratedLabel")}</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 form-field-answer">
                    {props.notice}
                </div>
            </div>
            <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                    <label className="form-label bold">{getText("PreventiveCare_CorrespondenceHistory_GenerationDateLabel")}</label>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 form-field-answer">
                    {props.generationDate}
                </div>
            </div>
        </div>
    );
}

export { CorrespondenceHistoryItem };
